/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateGame } from '../model/createGame';
import { GameEngineDto } from '../model/gameEngineDto';
import { GameEnginePageDto } from '../model/gameEnginePageDto';
import { PlayerCivilization } from '../model/playerCivilization';
import { PlayerColor } from '../model/playerColor';
import { PlayerNumber } from '../model/playerNumber';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class GameService {

    protected basePath = 'http://localhost:8080/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Create game
     * Create game
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createGame(body: CreateGame, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public createGame(body: CreateGame, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public createGame(body: CreateGame, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public createGame(body: CreateGame, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createGame.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/games`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Disjoin player
     * Desjoin player from game
     * @param gameId Game ID
     * @param playerNumber Player number
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public disjoinPlayer(gameId: number, playerNumber: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public disjoinPlayer(gameId: number, playerNumber: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public disjoinPlayer(gameId: number, playerNumber: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public disjoinPlayer(gameId: number, playerNumber: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling disjoinPlayer.');
        }

        if (playerNumber === null || playerNumber === undefined) {
            throw new Error('Required parameter playerNumber was null or undefined when calling disjoinPlayer.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/games/${encodeURIComponent(String(gameId))}/actions/disjoin/${encodeURIComponent(String(playerNumber))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get game
     * Get game
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGame(gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public getGame(gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public getGame(gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public getGame(gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling getGame.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GameEngineDto>('get',`${this.basePath}/api/games/${encodeURIComponent(String(gameId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get games
     * Get all games
     * @param ids Game IDs
     * @param page Page number
     * @param size Page size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGames(ids?: Array<number>, page?: number, size?: number, observe?: 'body', reportProgress?: boolean): Observable<GameEnginePageDto>;
    public getGames(ids?: Array<number>, page?: number, size?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEnginePageDto>>;
    public getGames(ids?: Array<number>, page?: number, size?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEnginePageDto>>;
    public getGames(ids?: Array<number>, page?: number, size?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ids) {
            ids.forEach((element) => {
                queryParameters = queryParameters.append('ids', <any>element);
            })
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GameEnginePageDto>('get',`${this.basePath}/api/games`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Join player
     * Join another player
     * @param gameId Game ID
     * @param userUuid User UUID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public joinPlayer(gameId: number, userUuid: string, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public joinPlayer(gameId: number, userUuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public joinPlayer(gameId: number, userUuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public joinPlayer(gameId: number, userUuid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling joinPlayer.');
        }

        if (userUuid === null || userUuid === undefined) {
            throw new Error('Required parameter userUuid was null or undefined when calling joinPlayer.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/games/${encodeURIComponent(String(gameId))}/actions/join/${encodeURIComponent(String(userUuid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set player civilization
     * Set player civilization
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setPlayerCivilization(body: PlayerCivilization, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public setPlayerCivilization(body: PlayerCivilization, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public setPlayerCivilization(body: PlayerCivilization, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public setPlayerCivilization(body: PlayerCivilization, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setPlayerCivilization.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling setPlayerCivilization.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/games/${encodeURIComponent(String(gameId))}/actions/civilization`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set player color
     * Set player color
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setPlayerColor(body: PlayerColor, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public setPlayerColor(body: PlayerColor, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public setPlayerColor(body: PlayerColor, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public setPlayerColor(body: PlayerColor, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setPlayerColor.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling setPlayerColor.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/games/${encodeURIComponent(String(gameId))}/actions/color`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set player number
     * Set player number
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setPlayerNumber(body: PlayerNumber, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public setPlayerNumber(body: PlayerNumber, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public setPlayerNumber(body: PlayerNumber, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public setPlayerNumber(body: PlayerNumber, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setPlayerNumber.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling setPlayerNumber.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/games/${encodeURIComponent(String(gameId))}/actions/number`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Start game
     * Start game
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public startGame(gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public startGame(gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public startGame(gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public startGame(gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling startGame.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/games/${encodeURIComponent(String(gameId))}/actions/start`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
